import * as actionTypes from './actionTypes';
import { paymentService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

const sendDataPaymentRequest = () => ({
  type: actionTypes.SEND_DATA_PAYMENT_REQUEST
});

const sendDataPaymentFailure = () => ({
  type: actionTypes.SEND_DATA_PAYMENT_FAILURE
});

export const sendDataPaymentSuccess = (data: any) => ({
  type: actionTypes.SEND_DATA_PAYMENT_SUCCESS,
  data
});

export const setDataPaymentConfirm = (data: any) => ({
  type: actionTypes.SET_DATA_PAYMENT_CONFIRM,
  data
});

export const sendDataPayment = (json, price: string) => {
  return async dispatch => {
    dispatch(sendDataPaymentRequest());
    try {
      if (isClient) {
        const data = await paymentService.post(json);

        dispatch(sendDataPaymentSuccess(data));
        (window as any).transaction  = data;
        (window as any).Culqi.publicKey = process.env.API_CULQUI_KEY;
        (window as any).Culqi.settings({
          title: 'Clasificados',
          currency: 'PEN',
          description: 'impreso clasificados',
          amount: Number(price.replace('.', '').replace(',', '')),
          order: data.order
        });
        (window as any).Culqi.options({
          lang: 'es',
          style: {
              logo: `${process.env.PATH_STATIC}/logo-clasificados.png`,
              maincolor: '#000000',
              buttontext: '#ffffff',
              maintext: '#333339',
              desctext: 'rgb(51, 51, 51)'
          }
      });
        (window as any).Culqi.open();
      }
    } catch(error) {
      dispatch(actionsModalError.openModalError());
      dispatch(sendDataPaymentFailure());
    }
  }
}

